export default "__VITE_ASSET__DCW2c7kw__"